import { WhmStack, WhmTypography } from "@securitize/reactjs-whm";
import { Translate } from "../../../Translation/Translate";
import TranslationKeys from "../../../../contexts/I18nContext/translationKeys";
import React from "react";
import { InvestorType, InvestorTypes } from "../../../../data/types/investors";

export default function SettingsTitles({
  investorType,
  entityName,
  fullName,
}: {
  investorType: InvestorType;
  entityName?: string;
  fullName?: string;
}) {
  return (
    <WhmStack>
      <WhmTypography variant="h4" fontWeight="bold" color="textPrimary">
        {investorType === InvestorTypes.ENTITY ? (
          <Translate
            translationKey={TranslationKeys.DELETE_SECURITY_CARD_TITLE_ENTITY}
            replacements={{ entityName: entityName! }}
          />
        ) : fullName ? (
          <Translate
            translationKey={
              TranslationKeys.DELETE_SECURITY_CARD_TITLE_INDIVIDUAL
            }
            replacements={{ fullName }}
          />
        ) : (
          <Translate
            translationKey={
              TranslationKeys.DELETE_SECURITY_CARD_TITLE_INDIVIDUAL_NO_NAME
            }
          />
        )}
      </WhmTypography>
      <WhmTypography variant="body2" color="textSecondary">
        {investorType === InvestorTypes.ENTITY ? (
          <Translate
            translationKey={
              TranslationKeys.DELETE_SECURITY_CARD_SUBTITLE_ENTITY
            }
          />
        ) : (
          <Translate
            translationKey={
              TranslationKeys.DELETE_SECURITY_CARD_SUBTITLE_INDIVIDUAL
            }
          />
        )}
      </WhmTypography>
    </WhmStack>
  );
}
